'use client';

import { cn, SeverityLevelsEnum, TStateCardProps } from 'types';

export const StatCard = ({ statCount, title, severityLevel = SeverityLevelsEnum.INFORMATION }: TStateCardProps) => {
  const getSeverityClasses = {
    [SeverityLevelsEnum.ERROR]: 'before:bg-poppy',
    [SeverityLevelsEnum.WARNING]: 'before:bg-oker',
    [SeverityLevelsEnum.SUCCESS]: 'before:bg-komorebi',
    [SeverityLevelsEnum.INFORMATION]: 'before:bg-blue',
  };

  return (
    <div
      className={cn(
        'flex flex-col items-center px-4 py-3 border border-neutralGrey rounded-lg bg-white relative overflow-hidden',
        'before:absolute before:top-0 before:left-0 before:h-full before:w-1 before:rounded-l-full',
        `${getSeverityClasses[severityLevel]}`
      )}
    >
      <h2 className="text-[2.5rem]/[140%] font-extrabold">{statCount}</h2>
      <p className="text-sm/[170%] font-extrabold text-concrete text-center">{title}</p>
    </div>
  );
};
